import React from 'react';

export const Pages = ({ pages = [], deprecatedPages = [] }) => {
  return pages.map((page, index) => <label>{deprecatedPages.includes(page) ?
    <span style={{ textDecoration: 'line-through' }}>{page}</span> :
    <span>{page}</span>}
    {(pages.length > 1 && index < pages.length - 1) && <span>, </span>}
  </label>)
}